// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 6.58594V23H3V1H15.4141L21 6.58594ZM7 11V20H9V13H11V20H13V13H15V20H17V12.5713C16.9999 11.7035 16.2965 11.0001 15.4287 11H7ZM14.5 7.5H19L14.5 3V7.5Z"}}]};

const FileMarkdownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-markdown-filled',
    ref,
    icon: element,
  },
));

FileMarkdownFilledIcon.displayName = 'FileMarkdownFilledIcon';

export default FileMarkdownFilledIcon;
